import { Crown } from 'lucide-react'

const Market = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-purple-900 to-slate-900 pt-16">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center py-12">
          <Crown className="w-16 h-16 text-yellow-400 mx-auto mb-4" />
          <h1 className="text-4xl font-bold text-white mb-2">Galactic Market</h1>
          <p className="text-gray-400">Trade resources and equipment with other empires</p>
          <p className="text-gray-500 mt-4">Coming Soon...</p>
        </div>
      </div>
    </div>
  )
}

export default Market